import React from "react";
import { MUSCLE_GROUPS } from "@/lib/exerciseLabels";
import { cn } from "@/lib/utils";

export function MuscleChips({ value, onChange, stats, lang }) {
  const L = lang === "id" ? "id" : "en";
  const locale = L === "id" ? "id-ID" : "en-US";
  const chips = [{ key: "all", id: "Semua", en: "All", n: stats?.total }, ...MUSCLE_GROUPS.map((g) => ({ ...g, n: stats?.groups?.[g.key] }))];
  return (
    <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1 no-scrollbar" data-testid="muscle-chips">
      {chips.filter((c) => c.key === "all" || c.n !== 0).map((c) => {
        const active = value === c.key;
        return (
          <button key={c.key} type="button" onClick={() => onChange(c.key)} data-testid={`muscle-chip-${c.key}`}
            className={cn("inline-flex shrink-0 items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors",
              active ? "border-primary bg-primary text-primary-foreground" : "bg-card text-muted-foreground hover:border-primary/40 hover:text-foreground")}>
            {c[L]}
            {c.n != null && <span className={cn("text-xs tabular-nums", active ? "opacity-80" : "opacity-60")}>{c.n.toLocaleString(locale)}</span>}
          </button>
        );
      })}
    </div>
  );
}
